<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader" />
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate" />
      <rule-game :title="ruleTitle.rule" :value="ruleGame" />
      <rule-game :title="ruleTitle.score" :value="ruleScore" />
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/tk/TK-Board.png';
import Tk1 from '../../assets/gamerule/tk/01.png';
import Tk2 from '../../assets/gamerule/tk/02.png';
import Tk3 from '../../assets/gamerule/tk/03.png';
import Tk4 from '../../assets/gamerule/tk/04.png';

export default {
  name: 'rule_tk_2cards',
  data() {
    return {
      ruleHeader: {
        gameName: 'ตีไก่ 2 ใบ (Dragon battle royal 2 Cards)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราการจ่าย',
        rule: 'กติกา',
        score: 'แต้มไพ่',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1:0.97',
          class: 'ml-3',
        },
        {
          type: 'text',
          text:
            'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text:
            'อัตราเดิมพันต่อรอบจะเท่ากับจำนวนเดิมพันหน้าห้องหนึ่งห้องจะมีผู้เล่นได้สูงสุด 6 คน และสามารถเริ่มเล่นได้ตั่งแต่ 2 คนขึ้นไป',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: 'จะเริ่มแจกจากคนแรกเรียงไปทางขวาตามลำดับจนถึงคนสุดท้าย',
          class: 'ml-3',
        },
        {
          type: 'text',
          text:
            'ผู้ที่ได้แต้มเยอะที่สุดจะได้กินรอบวงอันดับสองจ่ายอันดับหนึ่งเพียงคนเดียวและได้รับจากทั้งวง',
          class: 'ml-3',
        },
        {
          type: 'text',
          text:
            'ถึงผู้เล่นที่ได้แต้มน้อยที่สุดจะจ่ายรอบวงเมื่อเริ่มเกมส์ใหม่ผู้เล่นที่ได้แต้มมากที่สุดจากเกมส์ที่แล้วจะได้ไพ่เป็นคนแรกและแจกเรียงไปทางขวา',
          class: 'ml-3',
        },
      ],
      ruleScore: [
        {
          type: 'text',
          text:
            'ลำดับดอกไพ่เรียงจากมากไปน้อย โพธิ์ดำ > โพธิ์แดง > ข้าวหลามตัด > ดอกจิกตัวคุมเรียงจากมากไปน้อยเช่นกัน A>K>Q>J>10>9>8>7>6>5>4>3>2',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: Tk1,
          class: 'w-60',
        },
        {
          type: 'text',
          text:
            'หากได้ไพ่ K Q J สองใบให้ได้แต้มเท่ากับ 7.5แต้มหากได้ไพ่ดอกหรือแต้มเดียวกันจะได้ 2เด้ง',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: Tk2,
          class: 'w-50',
        },
        {
          type: 'text',
          text:
            'ไพ่ในมือบวกกันนับแต้ม แต้มใหญ่ชนะ โดยลำดับแต้มเรียงจากมากไปน้อย 9>8>7>6>5>4>3>2>1>บอด',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: Tk3,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'หากได้ 5 5 หรือ 10 10 จะได้ บอด 2 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: Tk4,
          class: 'w-50',
        },
      ],
    };
  },
};
</script>
